import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { breadcrumb } from '../../../helpers/page-front';

const Sidebar = props => {

    const active = "d-block u-link-v5 g-px-20 g-py-8 g-color-black g-bg-gray-light-v5 g-rounded-50 g-font-weight-600";
    const inactive = "d-block u-link-v5 g-px-20 g-py-8 g-color-gray-dark-v4 rounded";
    let title = breadcrumb(props).title;

    return (
        <div className="col-lg-3 g-brd-right--lg g-brd-gray-light-v4 g-mb-80 g-hidden-md-down">
            <div className="g-pr-15--lg">

                <h3 className="h4 g-color-black g-font-weight-600 g-pl-5">교육활동</h3>
                <ul className="list-unstyled g-font-size-13">
                    <li><Link to="/activity/visit" className={title === '교육소식' ? active : inactive}><i className="mr-2 fa fa-angle-right"></i> 교육소식</Link></li>
                    {/* <li><Link to="/activity/learn" className={title === '더배움' ? active : inactive}><i className="mr-2 fa fa-angle-right"></i> 더배움</Link></li> */} 
                    {/* <li><a href="https://forms.gle/kiv52SysZ5MYfpre9" target="_blink" className={inactive}><i className="mr-2 fa fa-angle-right"></i> 교구대여</a></li> */}
                    <li><Link to="/activity/calendar" className={title === '교육일정' ? active : inactive}><i className="mr-2 fa fa-angle-right"></i> 교육일정</Link></li>
                </ul>

                {/*
                <hr />
                <h3 className="h4 g-color-black g-font-weight-600 g-pl-5">동물영화제</h3>
                <ul className="list-unstyled g-font-size-13">
                     <li><Link to="/cinema/guide" className={title === '영화제 소개' ? active : inactive}><i className="mr-2 fa fa-angle-right"></i> 영화제 소개</Link></li> 
                    <li><Link to="/cinema/article" className={title === '영화제 소식' ? active : inactive}><i className="mr-2 fa fa-angle-right"></i> 영화제 소식</Link></li>
                    <li><Link to="/cinema/scene" className={title === '현장 스케치' ? active : inactive}><i className="mr-2 fa fa-angle-right"></i> 현장 스케치</Link></li>
                </ul>
                */}

                <hr />

                <h3 className="h4 g-color-black g-font-weight-600 g-pl-5">킁킁도서관</h3>
                <ul className="list-unstyled g-font-size-13">
                    <li><Link to="/library/intro" className={title === '도서관 소개' ? active : inactive}><i className="mr-2 fa fa-angle-right"></i> 도서관 소개</Link></li>
                    <li><Link to="/library/news" className={title === '도서관 소식' ? active : inactive}><i className="mr-2 fa fa-angle-right"></i> 도서관 소식</Link></li>
                    {/*<li><Link to="/library/day" className={title === '사서냥이의 하루' ? active : inactive}><i className="mr-2 fa fa-angle-right"></i> 사서냥이의 하루</Link></li>*/}
                    {/*<li><a href="https://www.instagram.com/kara_library/" target="_blink" className={inactive}><i className="mr-2 fa fa-angle-right"></i> 사서냥이의 하루</a></li>*/}
                </ul>

                <hr />

            </div>
        </div>
    )
}

export default withRouter(Sidebar);


// WEBPACK FOOTER //
// ./src/pages/front/board/sidebar.js